
export default {
	// Set by .env.development under "npm run serve", override in .env.local. Builds use the default.
	SERVER_BASE: process.env.VUE_APP_SERVER_BASE || "/branchstand_server/",
	API_URL: "https://kalls.se/headless/"
}